import React from 'react';
import { observer } from '../../shared/observer';
import { CartItemRow } from './CartItemRow';
import { RecycledTare } from './RecycledTare';
import { RecycledTareReturnPromise } from './RecycledTareReturnPromise';
import { TareModeSelect } from './TareModeSelect';
import { TareBalanceNote } from './TareBalanceNote';
import { NoTodaySaleNote } from './NoTodaySaleNote';
import { FreeDeliveryNote } from './FreeDeliveryNote';
import { curFormat } from '../../shared/format';
import { router } from '../../shared/hashRouter';
import { isFirstOrderUsed } from '../../shared/orderCount';
import { CheckoutForm } from './Checkout/CheckoutForm';
import { PaymentForm } from './Checkout/PaymentForm';
import { OrderSuccess } from './Checkout/OrderSuccess';
import { TareSignForm } from './Checkout/TareSignForm';

class CartAppView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentWillMount() {
    this._routerSub = router.subject.subscribe(() => this.forceUpdate());
  }
  componentWillUnmount() {
    if (this._routerSub) this._routerSub.unsubscribe();
  }

  clean = () => {
    if (!window.confirm('Очистить корзину?')) return;
    this.setState({ error: null });
    // стор очищает корзину оптимистично и сам возвращает её при ошибке —
    // здесь только показываем сообщение
    this.props.cart.cleanCart()
      .catch(() => this.setState({ error: 'Не удалось очистить корзину' }));
  };

  // наборы «только для первого заказа» у уже заказывавшего покупателя (#315)
  firstOrderUsedTitles() {
    return (this.props.cart.items || []).filter(isFirstOrderUsed).map((it) => it.title).join(', ');
  }

  goToCheckout = () => {
    if (this.firstOrderUsedTitles()) return;
    if (!this.props.auth.isAuthenticated) {
      this.props.auth.setLoginDialogOpen(true);
      return;
    }
    router.go('#checkout');
  };

  render() {
    const hash = router.hash;
    if (hash === '#checkout') return <CheckoutForm />;
    if (hash === '#tare_sign') return <TareSignForm />;
    if (hash === '#payment') return <PaymentForm />;
    if (hash === '#success') return <OrderSuccess />;
    return this.renderCart();
  }

  renderCart() {
    const cart = this.props.cart;
    const auth = this.props.auth;
    const items = cart.items;
    const cur = (auth.companyInfo.currency_hash && auth.companyInfo.currency_hash.symbol_html) || '';

    if (!items.length) {
      return (
        <div className="ng-cart-empty">
          <h1>Корзина пуста</h1>
          <p>Добавьте товары из каталога, чтобы оформить заказ.</p>
          <a className="btn" href="/catalog">Перейти в каталог</a>
        </div>
      );
    }

    // Блок тары: либо старое поведение (кнопка «Добавить тару» + счётчик к
    // обмену), либо выбор режима, если компания его включила.
    const tareInfo = (auth.companyInfo.cart_coupled) || {};
    const needTare = (cart.cart.need_coupled_count || 0) > 0;
    // сервер отдаёт пустой tare_modes, пока tare_modes_enabled = false
    const tareModesOn = !!(tareInfo.tare_modes_enabled && (tareInfo.tare_modes || []).length);
    // need_coupled_count = «сколько тары ещё не добавлено», и после выбора
    // rent/buy сервер добавляет строки, обнуляя его. Сам переключатель поэтому
    // гейтим по потребности корзины в таре (associated_coupled_items_count),
    // иначе блок исчезал бы сразу после выбора «в аренду»/«купить».
    const tareRelevant = (cart.cart.associated_coupled_items_count || 0) > 0;
    const showTareModes = tareModesOn && tareRelevant;
    // Счётчик «Бутылей к обмену» — легаси-путь: он добавляет недостающую тару
    // по полной цене, а сервер тут же пересобирает строки под выбранный режим
    // (см. crt#return_tare_promise), то есть значение просто откатывалось бы.
    // При включённых режимах управляет составом тары только переключатель.
    const showPromise = needTare && !tareModesOn;
    // кнопку «Добавить тару» прячем во всех режимах: состав тары ведёт сервер
    const showAddTare = needTare && !tareModesOn;
    const firstOrderUsed = this.firstOrderUsedTitles();

    return (
      <div className="ng-cart">
        <h1>Корзина</h1>

        <NoTodaySaleNote />

        <div className="ng-cart-list">
          {items.map((it) => (
            <CartItemRow key={it.item_id} item={it} />
          ))}
        </div>

        <TareBalanceNote />
        {showTareModes && <TareModeSelect />}
        {showAddTare && <RecycledTare />}
        {showPromise && <RecycledTareReturnPromise />}

        <FreeDeliveryNote />

        <div className="ng-cart-summary">
          <div className="ng-cart-summary__row">
            <span>Товары ({cart.cart.total_quantity || 0})</span>
            <strong>{curFormat(cart.totalSum)} {cur}</strong>
          </div>
          {cart.cart.bonus_earn_sum > 0 && (
            <div className="ng-cart-summary__row ng-cart-summary__row--muted">
              <span>Заработаете бонусов</span>
              <strong>{curFormat(cart.cart.bonus_earn_sum)} {cur}</strong>
            </div>
          )}
        </div>

        {this.state.error ? <div className="order-message">{this.state.error}</div> : null}
        {firstOrderUsed ? (
          <div className="order-message">
            Только для первого заказа: {firstOrderUsed}. Уберите из корзины, чтобы оформить заказ
          </div>
        ) : null}

        <div className="ng-cart-actions">
          <button type="button" className="btn" disabled={!!firstOrderUsed} onClick={this.goToCheckout}>Оформить заказ</button>
          <button type="button" className="btn btn--ghost" onClick={this.clean}>Очистить корзину</button>
        </div>
      </div>
    );
  }
}

export const CartApp = observer(CartAppView, ['cartStore', 'authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Cart/CartApp.jsx